import {EventEmitter, inject, Injectable} from "@angular/core";
import {MediaUploadComponent} from "../../libs/media/media-upload/media-upload.component";
import {isDefined} from "../../libs/utils/epic.utils";
import {MediaType} from "../../libs/media/media.type";
import {Observable} from "rxjs";
import {State} from "../../libs/enum/state.enum";
import {Belong} from "../../libs/enum/belong.enum";
import {SettingsService} from "../settings.service";
import {SettingKey} from "../../base/setting-key.enum";
import {DeletionProtection} from "../../libs/enum/deletion-protection.enum";
import {filter, map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class MediaUploadService {

  public static readonly DEFAULT_DELETION_PROTECTION: DeletionProtection = DeletionProtection.YEARS_2;

  private readonly settingsService: SettingsService = inject(SettingsService);

  private readonly changes: EventEmitter<State> = new EventEmitter<State>();
  // Component is added once globally in the AppComponent
  private mediaUpload: MediaUploadComponent | undefined;

  public setMediaUpload(mediaUpload: MediaUploadComponent): void {
    this.mediaUpload = mediaUpload;
    this.mediaUpload.accChanged.subscribe((v) => this.changes.emit(v));
    this.mediaUpload.setDefaultDeletionProtection(MediaUploadService.DEFAULT_DELETION_PROTECTION);
    this.settingsService.getOrgSettings().pipe(
      map((ss) => ss.find((s) => s.key === SettingKey.ORG_MEDIA_UPLOAD_DELETION_PROTECTION)),
      filter((s) => isDefined(s)),
      map((s) => s.value as DeletionProtection)
    ).subscribe((v) => {
      if (isDefined(this.mediaUpload)) {
        this.mediaUpload.setDefaultDeletionProtection(v);
      }
    });
  }

  public open(parentId: string, parentType: Belong, mediaType?: MediaType): Promise<boolean> {
    if (isDefined(this.mediaUpload)) {
      return this.mediaUpload.open(parentId, parentType, mediaType);
    }
    return Promise.resolve(false);
  }

  public close(): void {
    if (this.mediaUpload?.isOpen()) {
      this.mediaUpload.close();
    }
  }

  public accChanged(): Observable<State> {
    return this.changes.asObservable();
  }
}
